import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../environments/environment.development";
import { constantvalues } from "../../const";
import { DtoTicketStatusUpdate } from "../../models/ticket-details.model";
@Injectable({
    providedIn: 'root'
})

export class TicketManagementService {
    baseURL: string;
    constructor(private httpClient: HttpClient) {
        this.baseURL = environment.gatewayUrl;
    }

    createTicket(ticket: FormData) {
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.CREATE_TICKET}`, ticket);
    }

    uploadTicketDocument(ticket: FormData) {
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.UPLOAD_TICKET_DOCUMENT}`, ticket);
    }

    deleteTicket(ticketId: number) {
        return this.httpClient.delete(`${this.baseURL}${constantvalues.API_URL.DELETE_TICKET}`, {
            params: {
                ticketId: ticketId
            }
        });
    }

    updateTicketStatus(ticket: DtoTicketStatusUpdate) {
        return this.httpClient.put(`${this.baseURL}${constantvalues.API_URL.UPDATE_TICKET}`, ticket);
    }

    getAssignedTickets(pageSize: number, pageOffset: number, SearchTerm: string, sortColumn: string, sortDirection: string) {
        const payload = new HttpParams()
            .set('pageSize', pageSize.toString())
            .set('pageOffset', pageOffset.toString())
            .set('SearchTerm', SearchTerm)
            .set('SortColumn', sortColumn)
            .set('SortDirection', sortDirection);

        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.GET_ASSIGNED_TICKETS}`, { params: payload });
    }

    getTicketsRaisedByUser(pageSize: number, pageOffset: number, SearchTerm: string, sortColumn: string, sortDirection: string) {
        const payload = new HttpParams()
            .set('pageSize', pageSize.toString())
            .set('pageOffset', pageOffset.toString())
            .set('SearchTerm', SearchTerm)
            .set('SortColumn', sortColumn)
            .set('SortDirection', sortDirection);

        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.GET_TICKETS_RAISEDBY_USER}`, { params: payload });
    }
}